<div class="d-print-none">
  <abi-back-button></abi-back-button>
  <button abiPrint [beforePrint]="print.bind(this)">{{ 'System.Print' | translate }}</button>
  <!--button *ngIf="canDelete()" type="button" class="btn btn-danger" (click)="delete(deleteDlg)">
    <i class="fas fa-trash-alt"></i> Delete</button-->
</div>

<abi-spinner *ngIf="!job"></abi-spinner>
<div>
  <div class="w-100">
    <h4 class="header-txt text-center">{{ noteName|uppercase }}
      <img [src]="'assets/logos-big/' + tenant + '.svg?v=1'" class="tenant-logo header-logo" [alt]="tenant" />
    </h4>
  </div>
  <div class="card w-100" *ngIf="job">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <p><strong class="address">{{ companyName }}</strong></p>
          <p class="company-address">{{ addressLine1 }}</p>
          <p class="company-address">{{ addressLine2 }}</p>
          <p class="company-address">{{ addressLine3 }}</p>
          <p class="company-address">{{ postalCode }}</p>
        </div>
        <div class="col">
          <dl class="row">
            <dt class="col-4">Date</dt>
            <dd class="col-8">: {{ today|date }}</dd>

            <!--dt class="col-4">Order #</dt>
            <dd class="col-8">: {{ job.machines[0].deliveryNote }}</dd-->

            <dt class="col-4">Document #</dt>
            <dd class="col-8">: {{ job.machines[0].deliveryNote }}</dd>
          </dl>
          {{ job.noteExternal }}
        </div>
      </div>
      <div class="row">
        <div class="col">
          <dl class="row">
            <dt class="col-4">Reg no</dt>
            <dd class="col-8">: {{ registrationNumber }}</dd>

            <dt class="col-4">Vat No.</dt>
            <dd class="col-8">: {{ vatNumber }}</dd>
<!--
            <dt class="col-4">Exp Code</dt>
            <dd class="col-8">: 356282</dd>-->
          </dl>
        </div>
        <div class="col">
          <dl class="row">
            <dt class="col-4">Contact</dt>
            <dd class="col-8">: </dd>

            <dt class="col-4">Phone</dt>
            <dd class="col-8">: </dd>

            <dt class="col-4">Fax</dt>
            <dd class="col-8">: </dd>
          </dl>
        </div>
      </div>

      <div class="row">
        <div class="col">
          {{ websiteURL }}
        </div>
        <div class="col">
          <dl class="row">
            <dt class="col-4">e-mail</dt>
            <dd class="col-8">: {{ email }}</dd>
          </dl>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row">
        <div class="col">
          <p class="company-address"><strong>{{ job.contact | contact }}</strong></p>
          <p class="line-breaker">
            {{ job.address | address }}
          </p>
        </div>
        <div class="col">
          <dl class="row">
            <dt class="col-4">Cust Code</dt>
            <dd class="col-8">: {{ job.customerId }} </dd>

            <dt class="col-4">Phone</dt>
            <dd class="col-8">: {{ job.contact.mobile || job.contact.officeHours || job.contact.afterHours }} </dd>

            <dt class="col-4">e-mail</dt>
            <dd class="col-8">: {{ job.contact.emailAddress }} </dd>
          </dl>
          <dl class="row">
            <dt class="col-4">Warehouse</dt>
            <dd class="col-8">: {{ job.machines[0].machine.warehouseId }}</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <thead>
          <tr>
            <th *ngFor="let col of getColumns()" [ngClass]="columnStyle(col.field, col.reverse)">{{ col.header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of lines">
            <!--td>{{ line.customerId }}</td-->
            <td class="px15 0">
              <small>{{ line.sequence }}</small>
            </td>
            <td class="no-left-pad">
              <small>{{ line.machine.modelId }}</small>
            </td>
            <td class="no-left-pad">
              <small>{{ line.machine.name }}</small>
            </td>
            <td class="no-left-pad">
              <small>{{ line.machine.serialNumber }}</small>
            </td>
            <td class="no-left-pad">
              <small>{{ line.action }}</small>
            </td>
            <td class="no-left-pad">
              <small>{{ line.machine.locationId | lookupvalue:'CodeMachineLocation':false }}</small>
            </td>
            <td class="text-center px100">{{ ordered(line) }} </td>
          </tr>
        </tbody>
        <!--tfoot>
          <tr>
            <td colspan="4"></td>
            <td>
              <strong>Total</strong>
            </td>
            <td class="text-center px100">
              <strong>{{ 0 - job.machines.length }}</strong>
            </td>
          </tr>
        </tfoot-->
      </table>
    </div>
  </div>
</div>
